import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { UrlConstants } from '../../config/urlConstants';
import { DataService } from '../../service/data.service';
// import { UrlConstants } from '../../config/urlConstants';
import { LoaderService } from '../../service/loader.service';

@Injectable({
    providedIn: 'root',
})
export class LoaderInterceptor implements HttpInterceptor {
    private requests: HttpRequest<any>[] = [];
    private loaderService = inject(LoaderService);
    private dataService = inject(DataService);

    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i !== -1) {
            this.requests.splice(i, 1);
        }
        if (!this.loaderService.depositRedirectInProgress()) {
            this.loaderService.isLoading.next(this.requests.length > 0);
        }
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.requests.push(req);
        if (!(this.dataService.depositProcess() && req.url.includes(UrlConstants.DEPOSIT_STATUS_URI))) {
            this.loaderService.isLoading.next(true);
        }
        return new Observable((observer) => {
            const subscription = next.handle(req).subscribe({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        this.removeRequest(req);
                        observer.next(event);
                    }
                },
                error: (err) => {
                    this.removeRequest(req);
                    observer.error(err);
                },
                complete: () => {
                    this.removeRequest(req);
                    observer.complete();
                },
            });
            // remove request from queue when cancelled
            return () => {
                this.removeRequest(req);
                subscription.unsubscribe();
            };
        });
    }
}
